import { config, gameState } from '../index';

let slot = null;

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'EndScene',
    });
  }

  preload() {}

  create() {
    const cam = this.cameras.main;

    this.time.delayedCall(
      500,
      () => {
        cam.pan(640, 280, 1000, 'Power2');
        cam.zoomTo(1.4, 1000, 'Power2');
      },
      this,
    );

    this.ebg = this.add.image(0, 0, 'ebg').setOrigin(0, 0);
    slot = this.add.image(29, 24, 'slot').setOrigin(0, 0);

    if (gameState.level == 2) {
      slot.setTexture('slot1');
      //this.ebg.setTexture('ebg2')
    } else if (gameState.level == 3) {
      slot.setTexture('slot2');
      //this.ebg.setTexture('ebg3')
    } else {
      slot = this.add.image(29, 24, 'slot').setOrigin(0, 0);
    }

    this.anims.create({
      key: 'c2pop',
      frames: this.anims.generateFrameNames('chest2Anim', {
        start: 0,
        end: 12,
        prefix: 'CHESTTwo',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'c2close',
      frames: this.anims.generateFrameNames('chest2Anim', {
        start: 12,
        end: 0,
        prefix: 'CHESTTwo',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'c2open',
      frames: this.anims.generateFrameNames('chest2Anim', {
        start: 13,
        end: 69,
        prefix: 'CHESTTwo',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 2,
    });

    this.anims.create({
      key: 'pop1',
      frames: this.anims.generateFrameNames('Gem1Anim', {
        start: 0,
        end: 7,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'loop1',
      frames: this.anims.generateFrameNames('Gem1Anim', {
        start: 8,
        end: 40,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 33,
      repeat: 3,
    });

    this.anims.create({
      key: 'loop2',
      frames: this.anims.generateFrameNames('Gem2Anim', {
        start: 8,
        end: 40,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 33,
      repeat: 3,
    });

    this.anims.create({
      key: 'loop3',
      frames: this.anims.generateFrameNames('Gem3Anim', {
        start: 8,
        end: 40,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 33,
      repeat: 3,
    });

    this.anims.create({
      key: 'pop2',
      frames: this.anims.generateFrameNames('Gem2Anim', {
        start: 0,
        end: 7,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'pop3',
      frames: this.anims.generateFrameNames('Gem3Anim', {
        start: 0,
        end: 7,
        prefix: 'GEM',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.chestAudio = this.sound.add('chestOpen').setVolume(0.2);
    this.gemAudio = this.sound.add('gemReveal').setVolume(0.1);

    this.chest2 = this.add.sprite(640, 360, 'chest2Anim');

    this.gem1 = this.add.sprite(650, 340, 'Gem1Anim').setDepth(1);

    this.time.delayedCall(
      200,
      () => {
        this.chestAudio.play();
      },
      this,
    );

    this.time.delayedCall(
      500,
      () => {
        this.chest2.play('c2pop');
      },
      this,
    );

    this.time.delayedCall(
      700,
      () => {
        this.gemAudio.play();
        if (gameState.level == 2) {
          this.gem1.play('pop2');
        } else if (gameState.level == 3) {
          this.gem1.play('pop3');
        } else {
          this.gem1.play('pop1');
        }
        this.chest2.play('c2open');
      },
      this,
    );

    this.time.delayedCall(
      1800,
      () => {
        if (gameState.level == 2) {
          this.gem1.play('loop2');
        } else if (gameState.level == 3) {
          this.gem1.play('loop3');
        } else {
          this.gem1.play('loop1');
        }
      },
      this,
    );

    this.time.delayedCall(
      4800,
      () => {
        cam.pan(640, 360, 1000, 'Power2');
        cam.zoomTo(1, 1000, 'Power2');
      },
      this,
    );

    this.tweens.add({
      targets: this.gem1,
      x: () => {
        if (gameState.level == 1) {
          return 68;
        } else if (gameState.level == 2) {
          return 75;
        } else if (gameState.level == 3) {
          return 79;
        }
      },
      y: () => {
        if (gameState.level == 1) {
          return 105;
        } else if (gameState.level == 2) {
          return 174;
        } else if (gameState.level == 3) {
          return 245;
        }
      },
      scale: 0.4,
      //scale:{getEnd: function (){return 1.05 },getStart: function (){return 1 }},
      ease: 'Linear.easeInOut',
      duration: 800,
      delay: 6000,
      repeat: 0,
      yoyo: false,
    });

    this.time.delayedCall(
      6600,
      () => {
        this.chest2.play('c2close');
      },
      this,
    );

    this.time.delayedCall(
      6800,
      () => {
        this.gem1.setVisible(false);
        if (gameState.level == 1) {
          this.gemon = this.add.image(63, 70, 'gemon').setScale(1);
        } else if (gameState.level == 2) {
          this.gemon = this.add.image(71, 140, 'gemon2').setScale(1);
        } else if (gameState.level == 3) {
          this.gemon = this.add.image(75, 210, 'gemon3').setScale(1);
        }
      },
      this,
    );

    this.time.delayedCall(
      8600,
      () => {
        gameState.level++;
        // GameScene re-initializes its module-level state in create()
        this.scene.start('StartScene');
      },
      this,
    );
  }

  update() {}
}
